import { BREAKPOINTS } from '../constants/breakpoints';
import type { Breakpoint } from '../types/breakpoint';

/** Media query for "this breakpoint and up", e.g. for `window.matchMedia(mediaUp('md'))`. */
export function mediaUp(breakpoint: Exclude<Breakpoint, 'base'>): string {
    return `(min-width: ${BREAKPOINTS[breakpoint]}px)`;
}
